export const filterRolesByType = (roles, roleType) => {
  return roles?.filter((role) => role.role_type === roleType) || []
}

export const getAvailableRolesForReassignment = (roles, excludeRoleId) => {
  return roles?.filter((r) => r.id !== excludeRoleId) || []
}

export const filterPermissionsByColumn = (permissionsData, column) => {
  return permissionsData?.filter((p) => p.column === column) || []
}

export const createRoleMenuItems = (role, handlers, t, Icon, styles) => ({
  items: [
    {
      key: "edit",
      label: (
        <div className={styles.menuItem}>
          <Icon type="feather" name="Edit2" width={16} height={16} />
          <span>{t("staff.roles_access.edit")}</span>
        </div>
      ),
      onClick: () => handlers.onEdit(role)
    },
    {
      key: "delete",
      label: (
        <div className={styles.menuItemDelete}>
          <Icon type="feather" name="Trash2" width={16} height={16} color="var(--color-error)" />
          <span className={styles.menuItemDeleteText}>{t("staff.roles_access.delete")}</span>
        </div>
      ),
      onClick: () => handlers.onDelete(role)
    }
  ]
})

export const transformPermissionHashToUI = (permissionData) => {
  if (!permissionData || !Array.isArray(permissionData)) {
    return []
  }

  return permissionData.map((module, index) => {
    const moduleName = module.module_label || module.module_name || `Module ${module.module_id}`
    const moduleId = module.module_name || `module_${module.module_id}`

    const subPermissions = []
    let isEnabled = false

    module.screens?.forEach((screen) => {
      screen.actions?.forEach((action) => {
        const subPermId = `${moduleId}-${action.action_name}`

        const subPerm = {
          id: subPermId,
          label: action.action_label || action.action_name?.replace(/_/g, " "),
          key: action.action_name,
          screenKey: screen.screen_name,
          enabled: action.enabled === true,
          permission_id: action.permission_id,
          action_id: action.action_id,
          access_screen_id: screen.screen_id,
          scope_id: action.scope_id,
          scope_name: action.scope_name,
          scope_label: action.scope_label
        }

        if (action.available_scopes && Array.isArray(action.available_scopes) && action.available_scopes.length > 1) {
          subPerm.options = action.available_scopes.map((scope) => scope.label)
          subPerm.availableScopes = action.available_scopes

          if (action.enabled && action.scope_label) {
            subPerm.selectedScope = action.scope_label
          }
        }

        subPermissions.push(subPerm)
        if (action.enabled) isEnabled = true
      })
    })

    const column = index % 2 === 0 ? "left" : "right"
    const hasOnlyFullAccess = subPermissions.length === 1 && subPermissions[0].key === "full_access"

    return {
      id: moduleId,
      module_id: module.module_id,
      access_module_id: module.module_id,
      title: moduleName,
      helpText: module.help_text || null,
      column,
      iconName: getModuleIcon(moduleName),
      iconType: getModuleIconType(moduleName),
      subPermissions,
      hasOnlyFullAccess,
      isEnabled: hasOnlyFullAccess ? subPermissions[0].enabled : isEnabled
    }
  })
}

const getModuleIcon = (moduleName) => {
  const iconMap = {
    bookings: "booking",
    calendar: "calendar",
    clients: "user",
    messages: "messages",
    gallery: "gallery",
    marketing: "marketing",
    accounting: "finances",
    crew: "staff",
    equipment: "boat",
    experiences: "experiences",
    rentals: "rental"
  }

  const normalizedName = moduleName.toLowerCase()
  return iconMap[normalizedName] || "settings"
}

const getModuleIconType = (moduleName) => {
  const featherIcons = ["clients", "crew", "rentals"]
  const normalizedName = moduleName.toLowerCase()
  return featherIcons.includes(normalizedName) ? "feather" : "dsicon"
}

export const getInitialExpandedFromPermissions = (permissionData) => {
  if (!permissionData || !Array.isArray(permissionData)) {
    return {}
  }

  const expanded = {}
  permissionData.forEach((module) => {
    const moduleId = module.module_name || `module_${module.module_id}`
    const hasActive = module.screens?.some((screen) => screen.actions?.some((action) => action.enabled === true))
    expanded[moduleId] = hasActive
  })
  return expanded
}

export const getInitialSelectedTabsFromPermissions = (permissionData) => {
  if (!permissionData || !Array.isArray(permissionData)) {
    return {}
  }

  const selectedTabs = {}
  permissionData.forEach((module) => {
    const moduleId = module.module_name || `module_${module.module_id}`

    module.screens?.forEach((screen) => {
      screen.actions?.forEach((action) => {
        const tabId = `${moduleId}-${action.action_name}`

        if (action.enabled && action.scope_label && action.available_scopes?.length > 1) {
          selectedTabs[tabId] = action.scope_label
        } else if (action.available_scopes?.length > 1) {
          selectedTabs[tabId] = action.available_scopes[0]?.label || ""
        }
      })
    })
  })
  return selectedTabs
}

export const buildAssignPermissionPayload = (accessModuleId, subPerm, isActive, scope) => {
  const permissionAttribute = {
    id: subPerm.permission_id || null,
    access_screen_id: subPerm.access_screen_id,
    permission_action_id: subPerm.action_id,
    is_active: isActive
  }

  if (scope !== null && scope !== undefined) {
    if (typeof scope === "number") {
      permissionAttribute.permission_scope_id = scope
    } else if (typeof scope === "string") {
      const scopeItem = subPerm.availableScopes?.find((s) => s.label === scope || s.name === scope)
      if (scopeItem) {
        permissionAttribute.permission_scope_id = scopeItem.id
      }
    }
  }

  return {
    role: {
      permissions_attributes: [permissionAttribute]
    }
  }
}
